import { useState } from "react";
import { auth } from "../lib/supabase.js";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await auth.signIn(email, password);
    if (error) setError(error.message);
    setLoading(false);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#08080c" }}>
      <div style={{ width: 360, padding: 36, background: "#0d0d12", borderRadius: 16, border: "1px solid #1f1f3a" }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4, color: "#e0e0e0" }}>Clarifico</h1>
        <p style={{ fontSize: 13, color: "#555", marginBottom: 28 }}>Platform Admin</p>
        <form onSubmit={handleSubmit}>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
            style={{ width: "100%", padding: "10px 14px", marginBottom: 12, background: "#06060a", border: "1px solid #1f1f3a", borderRadius: 8, color: "#e0e0e0", fontSize: 14, outline: "none", boxSizing: "border-box" }} />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
            style={{ width: "100%", padding: "10px 14px", marginBottom: 16, background: "#06060a", border: "1px solid #1f1f3a", borderRadius: 8, color: "#e0e0e0", fontSize: 14, outline: "none", boxSizing: "border-box" }} />
          {error && <p style={{ color: "#f87171", fontSize: 12, marginBottom: 12 }}>{error}</p>}
          <button type="submit" disabled={loading}
            style={{ width: "100%", padding: "10px 0", background: "linear-gradient(135deg, #6366f1, #4f46e5)", border: "none", borderRadius: 8, color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
